import * as React from "react";

interface PropTypes {}

export const ExtraImageSvg: React.FC<PropTypes> = (props) => {
	return (
		<svg
			width={79}
			height={71}
			viewBox="0 0 79 71"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g filter="url(#filter0_di_1398_5200)">
				<rect
					x={8.6}
					y={8.59961}
					width={60.8}
					height={44.8}
					rx={12}
					fill="white"
				/>
			</g>
			<g filter="url(#filter1_di_1398_5200)">
				<path
					d="M22.2 27.7996C25.2928 27.7996 27.8 25.2924 27.8 22.1996C27.8 19.1068 25.2928 16.5996 22.2 16.5996C19.1072 16.5996 16.6 19.1068 16.6 22.1996C16.6 25.2924 19.1072 27.7996 22.2 27.7996Z"
					fill="#FFAB00"
				/>
			</g>
			<path
				opacity={0.16}
				d="M23.3717 53.3996H64.6C67.251 53.3996 69.4 51.2506 69.4 48.5996V38.7441L56.6043 25.9559C54.7949 24.1475 51.8152 24.1475 50.0057 25.9559L22.6 53.3461C22.8397 53.3728 23.1057 53.3996 23.3717 53.3996Z"
				fill="#0038B2"
			/>
			<g filter="url(#filter2_di_1398_5200)">
				<path
					d="M12.4179 53.2998C10.238 52.8466 8.6 50.9148 8.6 48.6004V47.353L21.1822 34.7917C23.0408 32.9366 26.1016 32.9366 27.9603 34.7917L46.6 53.4004H14.322C14.0488 53.4004 12.8 53.3454 12.5538 53.318C12.5081 53.3123 12.4629 53.3063 12.4179 53.2998Z"
					fill="#0050FF"
				/>
			</g>
			<defs>
				<filter
					id="filter0_di_1398_5200"
					x={0.599998}
					y={0.599609}
					width={92.8}
					height={76.8008}
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dx={8} dy={8} />
					<feGaussianBlur stdDeviation={8} />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.770709 0 0 0 0 0.792653 0 0 0 0 0.818587 0 0 0 0.16 0"
					/>
					<feBlend
						mode="normal"
						in2="BackgroundImageFix"
						result="effect1_dropShadow_1398_5200"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_1398_5200"
						result="shape"
					/>
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dx={-2} dy={-2} />
					<feGaussianBlur stdDeviation={2} />
					<feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.717499 0 0 0 0 0.740813 0 0 0 0 0.768367 0 0 0 0.48 0"
					/>
					<feBlend
						mode="normal"
						in2="shape"
						result="effect2_innerShadow_1398_5200"
					/>
				</filter>
				<filter
					id="filter1_di_1398_5200"
					x={12.6}
					y={12.5996}
					width={27.2}
					height={27.1992}
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dx={4} dy={4} />
					<feGaussianBlur stdDeviation={4} />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.717647 0 0 0 0 0.431373 0 0 0 0 0 0 0 0 0.16 0"
					/>
					<feBlend
						mode="normal"
						in2="BackgroundImageFix"
						result="effect1_dropShadow_1398_5200"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_1398_5200"
						result="shape"
					/>
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dx={-1} dy={-1} />
					<feGaussianBlur stdDeviation={1} />
					<feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.717647 0 0 0 0 0.431373 0 0 0 0 0 0 0 0 0.48 0"
					/>
					<feBlend
						mode="normal"
						in2="shape"
						result="effect2_innerShadow_1398_5200"
					/>
				</filter>
				<filter
					id="filter2_di_1398_5200"
					x={0.599998}
					y={25.4004}
					width={70}
					height={52}
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dx={8} dy={8} />
					<feGaussianBlur stdDeviation={8} />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0.470588 0 0 0 0 0.403922 0 0 0 0.16 0"
					/>
					<feBlend
						mode="normal"
						in2="BackgroundImageFix"
						result="effect1_dropShadow_1398_5200"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_1398_5200"
						result="shape"
					/>
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dx={-2} dy={-2} />
					<feGaussianBlur stdDeviation={2} />
					<feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0.470588 0 0 0 0 0.403922 0 0 0 0.48 0"
					/>
					<feBlend
						mode="normal"
						in2="shape"
						result="effect2_innerShadow_1398_5200"
					/>
				</filter>
			</defs>
		</svg>
	);
};
